// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// defineApp
export { defineApp } from './core/defineApp'
export type { RuntimeConfig } from './core/defineApp'
// plugins
export { Access, useAccess, useAccessMarkedRoutes } from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-access';
export { useAntdConfig, useAntdConfigSetter } from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-antd';
export { Provider, useModel } from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-model';
export { useRequest, UseRequestProvider, request, getRequestInstance } from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-request';
// plugins types.d.ts
export * from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-access/types.d';
export * from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-antd/types.d';
export * from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-layout/types.d';
export * from 'I:/小程序/guahao-console-main/src/.umi-production/plugin-request/types.d';
// @umijs/renderer-*
export { createBrowserHistory, createHashHistory, createMemoryHistory, Helmet, HelmetProvider, createSearchParams, generatePath, matchPath, matchRoutes, Navigate, NavLink, Outlet, resolvePath, useLocation, useMatch, useNavigate, useOutlet, useOutletContext, useParams, useResolvedPath, useRoutes, useSearchParams, useAppData, useClientLoaderData, useLoaderData, useRouteProps, useSelectedRoutes, useServerLoaderData, renderClient, __getRoot, Link, useRouteData, __useFetcher, withRouter } from 'I:/小程序/guahao-console-main/node_modules/@umijs/renderer-react';
export type { History, ClientLoader } from 'I:/小程序/guahao-console-main/node_modules/@umijs/renderer-react'
// umi/client/client/plugin
export { ApplyPluginsType, PluginManager } from 'I:/小程序/guahao-console-main/node_modules/umi/client/client/plugin.js';
export { history, createHistory } from './core/history';
export { terminal } from './core/terminal';
// react ssr
export const useServerInsertedHTML: Function = () => {};
